import {modals} from "@mantine/modals";
import AddEditFavoriteLinkModal from "@/components/SidebarLinks/AddEditFavoriteLinkModal/modal.tsx";
import {ILinkCategoryWithLinks} from "@/types/models/ILinkCategory.ts";
import {UserLinkEditable} from "@/components/SidebarLinks/ManageFavoriteLinksModal/modal.tsx";

export const ADD_EDIT_FAVORITE_LINK_MODAL_ID = "addEditFavoriteLinkModal"

export default function openAddEditFavoriteLinkModal(linkData: ILinkCategoryWithLinks[], favorites: UserLinkEditable[], reloadLinks: () => void, userLink?: UserLinkEditable) {
    modals.open({
        modalId: ADD_EDIT_FAVORITE_LINK_MODAL_ID,
        title: "Add Favorite Link",
        children: <AddEditFavoriteLinkModal linkData={linkData} favorites={favorites} userLink={userLink} reloadLinks={reloadLinks}/>
    })
}